import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import LikeButton from "../../like/like_button";
import Comments from "../../comment/comments";
import CommentForm from "../../comment/comment_form";
import LikeInformation from "../../like/like_information";
import NewsfeedItemFooterActions from "./newsfeed_item_footer_actions";
import NewsfeedItemFooterCommentButton from "./newsfeed_item_footer_comment_button";

import { isUndefined } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "NewsfeedItemFooter",

  propTypes: {
    user: GrPropTypes.user(),
    like: React.PropTypes.shape({
      key: React.PropTypes.string.isRequired,
      label: React.PropTypes.string.isRequired,
      canRate: React.PropTypes.bool.isRequired,
      rateable: React.PropTypes.bool.isRequired,
    }).isRequired,
    comment: React.PropTypes.shape({
      canComment: React.PropTypes.bool.isRequired,
      commentable: React.PropTypes.bool.isRequired,
      subjectKey: React.PropTypes.string.isRequired,
      subject: GrPropTypes.commentSubject(),
      subjectUrl: React.PropTypes.string,
      placeholder: React.PropTypes.string,
    }).isRequired,
    book: GrPropTypes.book(),
    additionalFooterLinks: React.PropTypes.arrayOf(React.PropTypes.element),
  },

  getDefaultProps() {
    return {
      like: {
        canRate: false,
        rateable: false,
      },
      comment: {
        canComment: false,
        commentable: false,
      },
    };
  },

  getCommentFormData(){
    const data = {
      subject: this.props.comment.subject,
      subjectKey: this.props.comment.subjectKey,
      authorUser: this.props.user,
    };
    if(this.props.comment.placeholder) {
      data.placeholder = this.props.comment.placeholder;
    }

    return data;
  },

  getDefaultFooterLinks(){
    const footerLinks = [];

    if (this.props.like.rateable && this.props.like.canRate) {
      footerLinks.push(<LikeButton resourceKey={this.props.like.key}
                        resourceLabel={this.props.like.label}/>);
    }
    
    if (this.props.comment.commentable && this.props.comment.canComment) {
      footerLinks.push(<NewsfeedItemFooterCommentButton
        subjectKey={this.props.comment.subjectKey}/>);
    }

    return footerLinks;
  },

  getFooterLinks(){
    const defaultFooterLinks = this.getDefaultFooterLinks();
    if (!isUndefined(this.props.additionalFooterLinks)) {
      return defaultFooterLinks.concat(this.props.additionalFooterLinks);
    } else {
      return defaultFooterLinks;
    }
  },

  render() {
    return (
      <div className="gr-newsfeedItem__footer">
        <NewsfeedItemFooterActions elements={this.getFooterLinks()} />

        <LikeInformation resourceKey={this.props.like.key}/>

        {
          this.props.comment.commentable ?
            <Comments
              subjectKey={this.props.comment.subjectKey}
              subjectUrl={this.props.comment.subjectUrl}
              subject={this.props.comment.subject}/> : null
        }

        {
          this.props.comment.canComment ?
            <CommentForm
            {...this.getCommentFormData()}/> : null
        }

      </div>
    );
  },
});
